<script lang="ts">
  import { Col, Image } from "sveltestrap";
  import data from "../../../Data/Contacts/Contacts.json"
  import {usersData} from "../../../store"
  let imgPath:string = "/assets/images/user"
   // for select contact
  const handleUser = (data) => {
    usersData.update(value => value = data)
  }
  let setUsersData:any
  usersData.subscribe((value)=>{
      setUsersData = value
  })
</script>
<Col xl="4" md="5" class="xl-50 box-col-6">
    <div class="nav flex-column nav-pills" id="v-pills-tab1" role="tablist" aria-orientation="vertical">
        {#each data.organizationdata as contactItem }
          <!-- svelte-ignore a11y-click-events-have-key-events -->
          <a class="nav-link {setUsersData.id == contactItem.id ? "active" : ""}" id={contactItem.id} on:click={()=>handleUser(contactItem)}>
            <div class="media">
              <Image fluid class="img-50 m-r-20 rounded-circle" src="{imgPath}/{contactItem.img}" alt="" />
              <div class="media-body">
                <h6>{contactItem.name}</h6>
                <p>{contactItem.email}</p>
              </div>
            </div>
          </a>
        {/each}
    </div>
</Col>